<div class="education-idea" [ngClass]="'education-idea--' + data.status">
  <div class="education-idea__name">{{data.name}}</div>

  <div class="education-idea__status">{{statusString}}</div>
</div>
